module.exports = __webpack_public_path__ + "static/caritas-55caa009c246d1936a26765240d36626.png";